export interface SortField {
  label: string;
  fieldName: string;
  key: string;
}

export interface SortValue {
  field: SortField;
  direction: 'asc' | 'desc';
}

export type SortDirection = 'asc' | 'desc';

export class SortRequest {
  sortProperties: string[];
  sortDirection: SortDirection;

  constructor(sortProperties: string[] = ['id'], sortDirection: SortDirection = 'asc') {
    this.sortProperties = sortProperties;
    this.sortDirection = sortDirection;
  }
}

export class Pagination {
  number: number;
  size: number;

  constructor(number: number = 0, size: number = 20) {
    this.number = number;
    this.size = size;
  }
}

export abstract class BaseFilter {
  sortRequest: SortRequest;
  pagination: Pagination;

  constructor(
    sortProperties: string[] = ['id'],
    sortDirection: SortDirection = 'asc',
    pageNumber: number = 0,
    pageSize: number = 20
  ) {
    this.sortRequest = new SortRequest(sortProperties, sortDirection);
    this.pagination = new Pagination(pageNumber, pageSize);
  }
}
